$(function () {
    $("#applicationForm").validate({
        rules: {
            name: {
                required: true
            },
            phone: {
                required: true,
                validPhone: true
            },
            country_code: {
                required: true,
            },
            password: {
                required: true,
                minlength: 8
            },
            password_confirmation: {
                required: true,
                equalTo: "#password"
            },
            email: {
                required: true,
                email: true,
                remote: {
                    type: "POST",
                    url: window.location.protocol + "//" + window.location.hostname + "/applications/check-email",
                },
                maxlength: 255
            },
        },
        messages: {
            email: {
                remote: "This email already exists"
            }
        },
        submitHandler: function (form) {
            var $btn = $(form).find('button[type="submit"], input[type="submit"]');
            if ($btn.prop('disabled')) {
                return false;
            }
            $btn.prop('disabled', true).addClass('disabled');
            $("#phone_number").val($("#phone").intlTelInput("getNumber"));
            form.submit();
        }
    });
});